import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { injectIntl, intlShape, FormattedMessage } from 'react-intl';
import { Row, Col, Button, Input, Alert } from 'reactstrap';
import FontAwesome from 'react-fontawesome';

import config from '../../../../config';

import { setCartItem, getCartItemByProduct, getCartItemFromProduct } from '../../CartActions';
import { getProductPrice, getProductMatchingPack } from '../../../Product/ProductActions';
import { getTranslation } from '../../../Intl/IntlActions';

import Price from '../../../Currency/components/view/Price';

class CartItemQuantitySelector extends Component {
    // static getDerivedStateFromProps(nextProps, prevState) {
    //     console.log('getDerivedStateFromProps', nextProps, prevState);
    //     if(nextProps.item && nextProps.item.quantity !== prevState.quantity) {
    //         return { quantity: nextProps.item.quantity };
    //     }
    //     return null;
    // }

    handleSubtract = () => {
        if(this.props.item.quantity > 1) {
            this.handleChangeQuantity(this.props.item.quantity - 1);
        }
    }

    handleAdd = () => {
        this.handleChangeQuantity((this.props.item.quantity || 1) + 1);
    }

    handleChange = event => {
        this.handleChangeQuantity(event.target.value);
    }

    handleChangeQuantity = newQuantity => {
        const matchingPack = getProductMatchingPack(this.props.product, newQuantity);
        this.props.dispatch(setCartItem(getCartItemFromProduct(this.props.product, newQuantity, matchingPack, this.props.intl.locale)));
    }

    handleAddToCart = () => {
        this.props.onAddToCart && this.props.onAddToCart();
    }

    render() {
        const { product, item, onCart, disableQuantityEdition } = this.props;
        const quantity = (item && item.quantity) || 1;
        const matchingPack = getProductMatchingPack(product, quantity);
        return (
            <Fragment>
                <Row noGutters className="mb-4 text-center text-lg-left">
                    <Col xs="12" xl={onCart ? 9 : 4}>
                        {
                            disableQuantityEdition
                            ? (
                                <span className="text-primary text-lg font-weight-bold">
                                    <FormattedMessage id="productUnitCountLabel" defaultMessage="{count} bottle(s)" values={{ count: quantity }} />
                                    <br />
                                    {config.application.name}<sup>&reg;</sup><br />
                                    {!onCart && matchingPack && matchingPack.freeCount > 0 ? <span className="text-warning font-weight-bold"><FormattedMessage id="productPackFreeCount" defaultMessage="+{count} free bottle(s)" values={{ count: matchingPack.freeCount }} /></span> : null}
                                </span>
                            )
                            : (
                                <Fragment>
                                    <span className="d-block mb-2 text-primary"><FormattedMessage id="quantity" defaultMessage="Quantity" /></span>
                                    <div className="d-flex">
                                        <span><Button color="secondary" size="sm" className="qty-control" onClick={this.handleSubtract}><FontAwesome name="minus" /></Button></span>
                                        <Input type="text" name="quantity" size="sm" value={quantity} className="border-0 bg-white w-25 text-secondary text-center" onChange={this.handleChange} />
                                        <span><Button color="secondary" size="sm" className="qty-control" onClick={this.handleAdd}><FontAwesome name="plus" /></Button></span>
                                    </div>
                                    {!onCart && matchingPack && matchingPack.freeCount > 0 ? <span className="text-warning font-weight-bold"><FormattedMessage id="productPackFreeCount" defaultMessage="+{count} free bottle(s)" values={{ count: matchingPack.freeCount }} /></span> : null}
                                </Fragment>
                            )
                        }

                    </Col>
                    <Col xs="12" sm="6" xl="3">
                        <span className="d-block mb-2 text-primary"><FormattedMessage id="priceHT" defaultMessage="Price excl. tax" /></span>
                        {product.priceHT !== matchingPack.unitPriceHT ? <span className="d-inline-block pr-2 text-crossed"><Price amount={product.priceHT * quantity} /></span> : <span>{' '}</span>}
                        <span className="h3 text-dark text-nowrap"><Price amount={matchingPack.unitPriceHT * quantity} /></span>
                    </Col>
                    {
                        onCart
                        ? null
                        : (
                            <Col xs="12" sm="6" xl="5" className="pt-3 text-center text-lg-right">
                                <Button color="warning" size="lg" onClick={this.handleAddToCart}><FormattedMessage id="cartAddToButton" defaultMessage="Add to cart" /></Button>
                            </Col>
                        )
                    }
                </Row>
            </Fragment>
        );
    }
}

function mapStateToProps(store, props) {
    return {
        item: getCartItemByProduct(store, props.product),
    };
}

CartItemQuantitySelector.defaultProps = {
    item: null,
    onCart: false,
    disableQuantityEdition: false,
    onAddToCart: null,
};

CartItemQuantitySelector.propTypes = {
    dispatch: PropTypes.func.isRequired,
    intl: intlShape.isRequired,
    product: PropTypes.object.isRequired,
    item: PropTypes.object,
    onCart: PropTypes.bool,
    disableQuantityEdition: PropTypes.bool,
    onAddToCart: PropTypes.func,
};

export default connect(mapStateToProps)(injectIntl(CartItemQuantitySelector));
